import { InjectionToken } from "@angular/core";

/**
 * You can provide main level reducers for your application from any feature modules with this token. Just register your reducer as a
 * {@link ReducerConfig} item using this token, adding `multi: true` to your provider definition.
 * @type {symbol} Main level reducer provider token.
 */
export const ReducerToken: InjectionToken<ReducerConfig> = new InjectionToken<ReducerConfig>("core.reducer.config");

/**
 * Simple reducer configuration type. The key is a property name for the global redux state and the value is the reducer function itself.
 */
export interface ReducerConfig {
    [key: string]: Function;
}
